import Typography from "@mui/material/Typography";
import { NoticeProps } from "react-select";
import { useTranslations } from "translations";
import { SelectOption } from "./types";

export function NoOptionsMessage({
  innerProps,
  selectProps,
}: NoticeProps<SelectOption>) {
  const translations = useTranslations();

  return (
    <Typography
      className={selectProps.classes.noOptionsMessage}
      color="textSecondary"
      {...(innerProps as any)}
    >
      {translations.general.noResult}
    </Typography>
  );
}
